import { getDomainWithoutWorkspace } from '../../../utils/helpers/url'
import { getQueryParam } from '../../../packages/kiti/utils/helpers/url'

const IntegrationMiddlewarePage = ({ workspace, location, service }) => {
  const state = getQueryParam('state')

  window.location.replace(
    `${location.protocol}//${workspace}.${getDomainWithoutWorkspace()}/integrations/${service}${location.search}`
  )

  return null
}

export default IntegrationMiddlewarePage
